<template>
  <v-card :color="'rgb(255, 255, 255)'" class="elevation-0 mx-0 mt-4">
    <v-card-text>
      <v-row class="mx-4 mt-4">
        <v-col cols="12" class="d-flex justify-end">
          <v-chip
            v-if="precioDisponibilidadResponse"
            label
            class="px-8 py-6"
            :color="precioDisponibilidadResponse.available ? 'green lighten-4' : 'red lighten-4'"
            :text-color="precioDisponibilidadResponse.available ? 'green darken-4' : 'red darken-4'"
          >
            <span class="price-chip-text">{{ formatearPrice(precioDisponibilidadResponse.price) }}</span>
          </v-chip>
        </v-col>
      </v-row>

      <v-row class="mx-4 mt-2 mb-6">
        <v-col cols="12" md="6">
          <v-row dense>
            <v-col cols="12">
              <v-autocomplete
                v-model="caminoSeleccionado"
                :items="caminos_correos"
                :filter="customAutocompleteFilter"
                :search-input="busquedaCamino"
                dense
                outlined
                hide-details="auto"
                clearable
                item-text="name"
                item-value="id"
                return-object
                label="Seleccione el camino"
                no-data-text="No hay caminos disponibles"
                @update:search-input="busquedaCamino = $event"
                @change="onChangeCamino"
                @blur="limpiarBusquedaCamino"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model.number="cantidadMochilas"
                type="number"
                dense
                outlined
                hide-details="auto"
                label="Equipajes"
                step="1"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6" class="d-flex">
          <v-row dense class="flex-grow-1">
            <v-col cols="12" class="d-flex justify-end">
              <v-chip
                class="px-6"
                label
                :color="formularioCompleto ? 'blue-grey darken-3' : 'blue-grey lighten-3'"
                :disabled="!formularioCompleto || loadingPrecioDisponibilidad"
                text-color="white"
                @click="onPrecioYDisponibilidad"
              >
                {{ loadingPrecioDisponibilidad ? 'Consultando...' : 'Precio y Disponibilidad' }}
              </v-chip>
            </v-col>
            <v-col cols="12" class="d-flex justify-end">
              <v-chip
                class="px-6"
                label
                :color="formularioCompleto ? 'green darken-2' : 'green lighten-3'"
                :disabled="!formularioCompleto || loadingCrearReserva"
                text-color="white"
                @click="onCrearReserva"
              >
                {{ loadingCrearReserva ? 'Creando...' : 'Crear Reserva' }}
              </v-chip>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row v-for="etapa in etapasIntermedias" :key="etapa.id || etapa.orden" class="mx-4 mb-4">
        <v-col cols="12">
          <v-card
            outlined
            :color="tieneTodosLosSelectsConValor(etapa) ? 'green lighten-5' : 'white'"
            :style="'border: 2px solid black'"
          >
            <v-card-text>
              <v-row dense>
                <v-col cols="12">
                  <strong>Fecha:</strong> {{ etapa.pivot ? etapa.pivot.fecha : "" }}
                </v-col>
                <v-col cols="12" md="6">
                  <strong>Inicio:</strong> {{ getNombrePunto(etapa.inicio_punto_id) }}
                </v-col>
                <v-col cols="12" md="6">
                  <strong>Fin:</strong> {{ getNombrePunto(etapa.final_punto_id) }}
                </v-col>
                <v-col cols="12" md="6">
                  <strong>Aloj:</strong> {{ getNombreAlojamientoAnterior(etapa) }}
                </v-col>
                <v-col cols="12" md="6">
                  <strong>Aloj:</strong> {{ getNombreAlojamiento(etapa) }}
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="stageInicioSeleccionadoPorEtapa[getEtapaKey(etapa)]"
                    :items="stagesCaminoSeleccionado"
                    :filter="customAutocompleteFilter"
                    :search-input="busquedaStageInicioPorEtapa[getEtapaKey(etapa)]"
                    dense
                    outlined
                    hide-details="auto"
                    clearable
                    item-text="location_name"
                    item-value="location_id"
                    return-object
                    label="Inicio"
                    no-data-text="Seleccione antes un camino"
                    @update:search-input="setBusquedaStageInicio(etapa, $event)"
                    @change="onChangeStageInicio(etapa)"
                    @blur="limpiarBusquedaStageInicio(etapa)"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="stageFinSeleccionadoPorEtapa[getEtapaKey(etapa)]"
                    :items="stagesCaminoSeleccionado"
                    :filter="customAutocompleteFilter"
                    :search-input="busquedaStageFinPorEtapa[getEtapaKey(etapa)]"
                    dense
                    outlined
                    hide-details="auto"
                    clearable
                    item-text="location_name"
                    item-value="location_id"
                    return-object
                    label="Fin"
                    no-data-text="Seleccione antes un camino"
                    @update:search-input="setBusquedaStageFin(etapa, $event)"
                    @change="onChangeStageFin(etapa)"
                    @blur="limpiarBusquedaStageFin(etapa)"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="alojamientoInicioSeleccionadoPorEtapa[getEtapaKey(etapa)]"
                    :items="getAlojamientosPorStage(stageInicioSeleccionadoPorEtapa[getEtapaKey(etapa)])"
                    :loading="isLoadingAlojamientosPorStage(stageInicioSeleccionadoPorEtapa[getEtapaKey(etapa)])"
                    :filter="customAutocompleteFilter"
                    :search-input="busquedaAlojamientoInicioPorEtapa[getEtapaKey(etapa)]"
                    dense
                    outlined
                    hide-details="auto"
                    clearable
                    return-object
                    label="Alojamiento Inicio"
                    no-data-text="No hay alojamientos para este stage"
                    @update:search-input="setBusquedaAlojamientoInicio(etapa, $event)"
                    @input="onChangeAlojamientoInicio(etapa, $event)"
                    @blur="limpiarBusquedaAlojamientoInicio(etapa)"
                  >
                    <template v-slot:item="{ item }">
                      <span>{{ getAlojamientoLabel(item) }}</span>
                    </template>
                    <template v-slot:selection="{ item }">
                      <span>{{ getAlojamientoLabel(item) }}</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="alojamientoFinSeleccionadoPorEtapa[getEtapaKey(etapa)]"
                    :items="getAlojamientosPorStage(stageFinSeleccionadoPorEtapa[getEtapaKey(etapa)])"
                    :loading="isLoadingAlojamientosPorStage(stageFinSeleccionadoPorEtapa[getEtapaKey(etapa)])"
                    :filter="customAutocompleteFilter"
                    :search-input="busquedaAlojamientoFinPorEtapa[getEtapaKey(etapa)]"
                    dense
                    outlined
                    hide-details="auto"
                    clearable
                    return-object
                    label="Alojamiento Fin"
                    no-data-text="No hay alojamientos para este stage"
                    @update:search-input="setBusquedaAlojamientoFin(etapa, $event)"
                    @input="onChangeAlojamientoFin(etapa, $event)"
                    @blur="limpiarBusquedaAlojamientoFin(etapa)"
                  >
                    <template v-slot:item="{ item }">
                      <span>{{ getAlojamientoLabel(item) }}</span>
                    </template>
                    <template v-slot:selection="{ item }">
                      <span>{{ getAlojamientoLabel(item) }}</span>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "ApiCorreosTab",
  props: {
    
    modelReserva: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    caminoSeleccionado: null,
    cantidadMochilas: 0,
    busquedaCamino: "",
    stageInicioSeleccionadoPorEtapa: {},
    stageFinSeleccionadoPorEtapa: {},
    busquedaStageInicioPorEtapa: {},
    busquedaStageFinPorEtapa: {},
    alojamientoInicioSeleccionadoPorEtapa: {},
    alojamientoFinSeleccionadoPorEtapa: {},
    busquedaAlojamientoInicioPorEtapa: {},
    busquedaAlojamientoFinPorEtapa: {},
    alojamientosPorLocalidad: {},
    loadingAlojamientosPorLocalidad: {},
    pendingAlojamientosPorLocalidad: {},
    colaAlojamientos: [],
    procesandoColaAlojamientos: false,
    loadingPrecioDisponibilidad: false,
    loadingCrearReserva: false,
    precioDisponibilidadResponse: null,
  }),

  computed: {
   ...mapState("auth", ["access_token", "user", "masterProveedores"]),
   ...mapState("apicorreos", ["caminos_correos", "correos_access_token"]),
   ...mapState("puntos", ["puntos"]),

    etapasIntermedias() {
      const etapas = this.modelReserva?.etapas || [];
      if (etapas.length <= 2) {
        return [];
      }

      return etapas.slice(1, -1);
    },

    stagesCaminoSeleccionado() {
      return [...(this.caminoSeleccionado?.stages || [])]
        .sort((a, b) => String(a?.location_name || "").localeCompare(String(b?.location_name || ""), "es", { sensitivity: "base" }));
    },

    formularioCompleto() {
      if (!this.caminoSeleccionado || !Number.isInteger(Number(this.cantidadMochilas)) || Number(this.cantidadMochilas) <= 0) {
        return false;
      }

      return this.etapasIntermedias.every((etapa) => this.tieneTodosLosSelectsConValor(etapa));
    },

    payloadPrecioDisponibilidad() {
      const stages = {};

      this.etapasIntermedias.forEach((etapa) => {
        const etapaKey = this.getEtapaKey(etapa);
        const fecha = etapa?.pivot?.fecha;
        const alojamientoInicio = this.alojamientoInicioSeleccionadoPorEtapa[etapaKey];
        const alojamientoFin = this.alojamientoFinSeleccionadoPorEtapa[etapaKey];

        if (!fecha) {
          return;
        }

        stages[fecha] = {
          accommodation_start: this.getAlojamientoId(alojamientoInicio),
          accommodation_end: this.getAlojamientoId(alojamientoFin),
        };
      });

      return {
        camino: this.caminoSeleccionado?.id || null,
        rucksacks: Number(this.cantidadMochilas),
        stages,
      };
    },

    payloadCrearReserva() {
      const cliente = this.modelReserva?.cliente || {};

      return {
        camino: this.caminoSeleccionado?.id || null,
        rucksacks: Number(this.cantidadMochilas),
        client: {
          email: cliente?.email || "",
          name: cliente?.nombre || "",
          surname: cliente?.apellidos || "",
          phone: cliente?.telefono || "",
          address: cliente?.direccion || "",
          cp: cliente?.cp || cliente?.codigo_postal || "",
          city: cliente?.city || cliente?.ciudad || cliente?.poblacion || "",
          country: cliente?.country || cliente?.pais || cliente?.nacionalidad || "",
          dni: cliente?.dni || cliente?.documento || "",
          file: cliente?.file || cliente?.fichero || "",
          i18n: cliente?.i18n || cliente?.idioma || "es",
        },
        stages: this.payloadPrecioDisponibilidad?.stages || {},
      };
    },
  },

  watch: {
    caminoSeleccionado: {
      immediate: false,
      handler() {
        this.preseleccionarStages();
      },
    },
    caminos_correos: {
      immediate: true,
      handler() {
        this.preseleccionarCaminoPorReserva();
      },
    },
    "modelReserva.camino_correo_id": {
      immediate: true,
      handler() {
        this.preseleccionarCaminoPorReserva();
      },
    },
    "modelReserva.camino.ref_correo_id": {
      immediate: true,
      handler() {
        this.preseleccionarCaminoPorReserva();
      },
    },
    "modelReserva.camino.ref_camino": {
      immediate: true,
      handler() {
        this.preseleccionarCaminoPorReserva();
      },
    },
    "modelReserva.ref_camino": {
      immediate: true,
      handler() {
        this.preseleccionarCaminoPorReserva();
      },
    },
  },

  mounted() {
    this.cantidadMochilas = Number(this.modelReserva?.cant_peregrinos || 0);
    this._getPuntos();
    this._getToken();
  },

  methods: {
    ...mapActions("apicorreos", ["getToken", "getCaminos", "getAlojamientosPorLocalidad", "getPrecioDisponibilidad", "createBooking"]),
    ...mapActions("puntos", ["getPuntos"]),
    ...mapActions("reservas", [
      "updateReservaServicioCoste",
      "updateCaminoCorreoIdReserva",
      "updateAlojamientoCorreoInicioIdEtapa",
      "updateAlojamientoCorreoFinIdEtapa",
    ]),
    ...mapActions("proveedores", ["updateRefAlojamientoCorreoIdProveedor"]),

    async _getPuntos() {
      await this.getPuntos([this.access_token, false]);
    },

    async _getToken() {
      let res = await this.getToken([this.access_token]);
      if (res) {
        this._getCaminos();
      }
    },

    async _getCaminos() {
      let res = await this.getCaminos([this.access_token, this.correos_access_token]);
      if (res) {
        
      }
    },

    limpiarBusquedaCamino() {
      this.busquedaCamino = "";
    },

    async onChangeCamino(selectedValue) {
      this.limpiarBusquedaCamino();
      const caminoCorreoId = selectedValue?.id ?? this.caminoSeleccionado?.id ?? null;
      await this.persistirCaminoCorreoId(caminoCorreoId);
    },

    async persistirCaminoCorreoId(caminoCorreoId) {
      const reservaId = this.modelReserva?.id;
      if (!reservaId || !this.access_token) {
        return;
      }

      if (String(this.modelReserva?.camino_correo_id ?? "") === String(caminoCorreoId ?? "")) {
        return;
      }

      try {
        const res = await this.updateCaminoCorreoIdReserva([
          this.access_token,
          reservaId,
          caminoCorreoId,
        ]);

        if (res && res.id == reservaId) {
          this.modelReserva.camino_correo_id = res.camino_correo_id;
        } else {
          this.modelReserva.camino_correo_id = caminoCorreoId;
        }
      } catch (error) {
        console.error("Error al actualizar camino_correo_id:", error);
      }
    },

    async preseleccionarCaminoPorReserva() {
      const caminoCorreoIdActual = this.modelReserva?.camino_correo_id;
      const refCaminoFallback = this.modelReserva?.camino?.ref_camino
        ?? this.modelReserva?.camino?.ref_correo_id
        ?? this.modelReserva?.ref_camino;
      const refCorreoId = caminoCorreoIdActual ?? refCaminoFallback;
      const caminos = Array.isArray(this.caminos_correos) ? this.caminos_correos : [];

      if (!refCorreoId || caminos.length === 0) {
        return;
      }

      const refCorreoIdNormalizado = String(refCorreoId);
      const caminoCoincidente = caminos.find((camino) => String(camino?.id) === refCorreoIdNormalizado);

      if (!caminoCoincidente) {
        return;
      }

      if (String(this.caminoSeleccionado?.id || "") === refCorreoIdNormalizado) {
        if (!caminoCorreoIdActual && refCaminoFallback) {
          await this.persistirCaminoCorreoId(this.caminoSeleccionado?.id ?? refCaminoFallback);
        }
        return;
      }

      this.caminoSeleccionado = caminoCoincidente;

      if (!caminoCorreoIdActual && refCaminoFallback) {
        await this.persistirCaminoCorreoId(caminoCoincidente?.id ?? refCaminoFallback);
      }
    },

    getEtapaKey(etapa) {
      return etapa?.pivot?.id || etapa?.id || etapa?.orden;
    },

    setBusquedaStageInicio(etapa, value) {
      this.$set(this.busquedaStageInicioPorEtapa, this.getEtapaKey(etapa), value);
    },

    limpiarBusquedaStageInicio(etapa) {
      this.$set(this.busquedaStageInicioPorEtapa, this.getEtapaKey(etapa), "");
    },

    setBusquedaStageFin(etapa, value) {
      this.$set(this.busquedaStageFinPorEtapa, this.getEtapaKey(etapa), value);
    },

    limpiarBusquedaStageFin(etapa) {
      this.$set(this.busquedaStageFinPorEtapa, this.getEtapaKey(etapa), "");
    },

    setBusquedaAlojamientoInicio(etapa, value) {
      this.$set(this.busquedaAlojamientoInicioPorEtapa, this.getEtapaKey(etapa), value);
    },

    limpiarBusquedaAlojamientoInicio(etapa) {
      this.$set(this.busquedaAlojamientoInicioPorEtapa, this.getEtapaKey(etapa), "");
    },

    setBusquedaAlojamientoFin(etapa, value) {
      this.$set(this.busquedaAlojamientoFinPorEtapa, this.getEtapaKey(etapa), value);
    },

    limpiarBusquedaAlojamientoFin(etapa) {
      this.$set(this.busquedaAlojamientoFinPorEtapa, this.getEtapaKey(etapa), "");
    },

    formatearPrice(price) {
      const valor = Number(price || 0);
      return `${valor.toFixed(2)} EUR`;
    },

    tieneTodosLosSelectsConValor(etapa) {
      const etapaKey = this.getEtapaKey(etapa);

      return Boolean(
        this.stageInicioSeleccionadoPorEtapa[etapaKey]
        && this.stageFinSeleccionadoPorEtapa[etapaKey]
        && this.alojamientoInicioSeleccionadoPorEtapa[etapaKey]
        && this.alojamientoFinSeleccionadoPorEtapa[etapaKey]
      );
    },

    getNombrePunto(puntoId) {
      return this.puntos.find(punto => punto.id == puntoId)?.nombre || "";
    },

    getNombreAlojamiento(etapa) {
      return etapa?.proveedor?.nombre_alias || etapa?.pivot?.proveedor_nombre || "";
    },

    getNombreAlojamientoAnterior(etapa) {
      const etapaAnterior = this.getEtapaAnterior(etapa);
      return etapaAnterior?.proveedor?.nombre_alias || etapaAnterior?.pivot?.proveedor_nombre || "";
    },

    getEtapaAnterior(etapa) {
      const etapas = this.modelReserva?.etapas || [];
      const etapaKey = this.getEtapaKey(etapa);
      const index = etapas.findIndex((item) => this.getEtapaKey(item) == etapaKey);

      if (index <= 0) {
        return null;
      }

      return etapas[index - 1] || null;
    },

    getProveedorDeEtapa(etapa) {
      if (!etapa) {
        return null;
      }

      if (etapa?.proveedor) {
        return etapa.proveedor;
      }

      const proveedorId = etapa?.pivot?.proveedor_id ?? etapa?.proveedor_id;
      if (!proveedorId) {
        return null;
      }

      const proveedores = Array.isArray(this.masterProveedores) ? this.masterProveedores : [];
      return proveedores.find((proveedor) => String(proveedor?.id) === String(proveedorId)) || null;
    },

    getProveedorAlojamientoInicio(etapa) {
      return this.getProveedorDeEtapa(this.getEtapaAnterior(etapa));
    },

    getProveedorAlojamientoFin(etapa) {
      return this.getProveedorDeEtapa(etapa);
    },

    getServicioCorreos() {
      const servicios = Array.isArray(this.modelReserva?.servicios) ? this.modelReserva.servicios : [];
      return servicios.find((servicio) => {
        const proveedorNombre = String(servicio?.proveedor_nombre || "").trim().toUpperCase();
        return proveedorNombre.startsWith("SOCIEDAD ESTATAL CORREOS");
      }) || null;
    },

    normalizarTexto(texto) {
      return String(texto || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim()
        .toLowerCase();
    },

    customAutocompleteFilter(item, queryText, itemText) {
      const textoItem = this.normalizarTexto(itemText || item?.location_name || item?.name || item?.nombre || item?.title);
      const textoBusqueda = this.normalizarTexto(queryText);

      if (!textoBusqueda) {
        return true;
      }

      return textoItem.includes(textoBusqueda);
    },

    getStageCoincidente(nombrePunto) {
      const nombreNormalizado = this.normalizarTexto(nombrePunto);
      if (!nombreNormalizado) {
        return null;
      }

      return this.stagesCaminoSeleccionado.find((stage) => {
        const locationName = this.normalizarTexto(stage?.location_name);
        return locationName.startsWith(nombreNormalizado);
      }) || null;
    },

    preseleccionarStages() {
      const seleccionadosInicio = {};
      const seleccionadosFin = {};

      this.etapasIntermedias.forEach((etapa) => {
        const etapaKey = this.getEtapaKey(etapa);
        seleccionadosInicio[etapaKey] = this.getStageCoincidente(this.getNombrePunto(etapa?.inicio_punto_id));
        seleccionadosFin[etapaKey] = this.getStageCoincidente(this.getNombrePunto(etapa?.final_punto_id));
      });

      this.stageInicioSeleccionadoPorEtapa = seleccionadosInicio;
      this.stageFinSeleccionadoPorEtapa = seleccionadosFin;
      this.cargarAlojamientosPreseleccionados();
    },

    getLocationId(stage) {
      return stage?.location_id || null;
    },

    getAlojamientosPorStage(stage) {
      const locationId = this.getLocationId(stage);
      if (!locationId) {
        return [];
      }

      return [...(this.alojamientosPorLocalidad[locationId] || [])]
        .sort((a, b) => this.getAlojamientoLabel(a).localeCompare(this.getAlojamientoLabel(b), "es", { sensitivity: "base" }));
    },

    isLoadingAlojamientosPorStage(stage) {
      const locationId = this.getLocationId(stage);
      return Boolean(locationId && this.loadingAlojamientosPorLocalidad[locationId]);
    },

    getAlojamientoLabel(alojamiento) {
      return alojamiento?.name || alojamiento?.nombre || alojamiento?.title || "";
    },

    getAlojamientoId(alojamiento) {
      return alojamiento?.id || alojamiento?.accommodation_id || alojamiento?.value || null;
    },

    getAlojamientoPorId(alojamientos, alojamientoId) {
      if (!alojamientoId) {
        return null;
      }

      return (alojamientos || []).find(
        (alojamiento) => String(this.getAlojamientoId(alojamiento)) === String(alojamientoId)
      ) || null;
    },

    getRefAlojamientoCorreoIdProveedor(proveedor) {
      const refId = proveedor?.ref_alojamiento_correo_id;
      if (refId === null || refId === undefined || refId === "") {
        return null;
      }
      return refId;
    },

    getAlojamientoPorReferenciaProveedor(alojamientos, proveedor) {
      return this.getAlojamientoPorId(alojamientos, this.getRefAlojamientoCorreoIdProveedor(proveedor));
    },

    getAlojamientoPreferido(alojamientos, { alojamientoIdPivot = null, proveedor = null, nombreAlojamiento = "" } = {}) {
      return this.getAlojamientoPorId(alojamientos, alojamientoIdPivot)
        || this.getAlojamientoPorReferenciaProveedor(alojamientos, proveedor)
        || this.getAlojamientoCoincidente(alojamientos, nombreAlojamiento);
    },

    getReservaEtapaProveedorId(etapa) {
      return etapa?.pivot?.id || null;
    },

    async persistirAlojamientoCorreoInicioIdEtapa(etapa, alojamientoCorreoInicioId) {
      const reservaId = this.modelReserva?.id;
      const reservaEtapaProveedorId = this.getReservaEtapaProveedorId(etapa);
      const valor = alojamientoCorreoInicioId ?? null;

      if (!reservaId || !reservaEtapaProveedorId || !this.access_token) {
        return;
      }

      if (String(etapa?.pivot?.alojamiento_correo_inicio_id ?? "") === String(valor ?? "")) {
        return;
      }

      try {
        await this.updateAlojamientoCorreoInicioIdEtapa([
          this.access_token,
          reservaId,
          reservaEtapaProveedorId,
          valor,
        ]);
        this.$set(etapa.pivot, "alojamiento_correo_inicio_id", valor);
      } catch (error) {
        console.error("Error al persistir alojamiento_correo_inicio_id:", error);
      }
    },

    async persistirAlojamientoCorreoFinIdEtapa(etapa, alojamientoCorreoFinId) {
      const reservaId = this.modelReserva?.id;
      const reservaEtapaProveedorId = this.getReservaEtapaProveedorId(etapa);
      const valor = alojamientoCorreoFinId ?? null;

      if (!reservaId || !reservaEtapaProveedorId || !this.access_token) {
        return;
      }

      if (String(etapa?.pivot?.alojamiento_correo_fin_id ?? "") === String(valor ?? "")) {
        return;
      }

      try {
        await this.updateAlojamientoCorreoFinIdEtapa([
          this.access_token,
          reservaId,
          reservaEtapaProveedorId,
          valor,
        ]);
        this.$set(etapa.pivot, "alojamiento_correo_fin_id", valor);
      } catch (error) {
        console.error("Error al persistir alojamiento_correo_fin_id:", error);
      }
    },

    async persistirRefAlojamientoCorreoIdProveedor(proveedor, alojamientoSeleccionado) {
      const proveedorId = proveedor?.id ?? proveedor?.proveedor_id ?? proveedor?.pivot?.proveedor_id;
      const refAlojamientoCorreoId = this.getAlojamientoId(alojamientoSeleccionado);

      if (!proveedorId || !this.access_token || !refAlojamientoCorreoId) {
        return;
      }

      if (String(proveedor?.ref_alojamiento_correo_id ?? "") === String(refAlojamientoCorreoId)) {
        return;
      }

      try {
        const response = await this.updateRefAlojamientoCorreoIdProveedor([
          this.access_token,
          proveedorId,
          refAlojamientoCorreoId,
        ]);
        const nuevoRefId = response?.ref_alojamiento_correo_id ?? refAlojamientoCorreoId;

        if (proveedor) {
          this.$set(proveedor, "ref_alojamiento_correo_id", nuevoRefId);
        }
      } catch (error) {
        console.error("Error al actualizar ref_alojamiento_correo_id del proveedor:", error);
      }
    },

    getAlojamientoCoincidente(alojamientos, nombreAlojamiento) {
      const nombreNormalizado = this.normalizarTexto(nombreAlojamiento);
      if (!nombreNormalizado) {
        return null;
      }

      return (alojamientos || []).find((alojamiento) => {
        const alojamientoNormalizado = this.normalizarTexto(this.getAlojamientoLabel(alojamiento));
        return alojamientoNormalizado === nombreNormalizado
          || alojamientoNormalizado.includes(nombreNormalizado)
          || nombreNormalizado.includes(alojamientoNormalizado);
      }) || null;
    },

    normalizarAlojamientosResponse(response) {
      if (Array.isArray(response)) {
        return response;
      }

      if (Array.isArray(response?.data)) {
        return response.data;
      }

      if (Array.isArray(response?.accommodations)) {
        return response.accommodations;
      }

      return [];
    },

    encolarCargaAlojamientos(locationId) {
      if (!locationId) {
        return Promise.resolve([]);
      }

      if (this.alojamientosPorLocalidad[locationId]) {
        return Promise.resolve(this.alojamientosPorLocalidad[locationId]);
      }

      if (this.pendingAlojamientosPorLocalidad[locationId]) {
        return this.pendingAlojamientosPorLocalidad[locationId];
      }

      const requestPromise = new Promise((resolve, reject) => {
        this.colaAlojamientos.push({ locationId, resolve, reject });
      });

      this.pendingAlojamientosPorLocalidad[locationId] = requestPromise;
      this.procesarColaAlojamientos();

      return requestPromise;
    },

    async procesarColaAlojamientos() {
      if (this.procesandoColaAlojamientos) {
        return;
      }

      this.procesandoColaAlojamientos = true;

      while (this.colaAlojamientos.length > 0) {
        const { locationId, resolve, reject } = this.colaAlojamientos.shift();

        if (this.alojamientosPorLocalidad[locationId]) {
          resolve(this.alojamientosPorLocalidad[locationId]);
          delete this.pendingAlojamientosPorLocalidad[locationId];
          continue;
        }

        this.$set(this.loadingAlojamientosPorLocalidad, locationId, true);

        try {
          const response = await this.getAlojamientosPorLocalidad([
            this.access_token,
            this.correos_access_token,
            locationId,
          ]);
          const alojamientos = this.normalizarAlojamientosResponse(response);
          this.$set(this.alojamientosPorLocalidad, locationId, alojamientos);
          resolve(alojamientos);
        } catch (error) {
          reject(error);
        } finally {
          this.$set(this.loadingAlojamientosPorLocalidad, locationId, false);
          delete this.pendingAlojamientosPorLocalidad[locationId];
        }
      }

      this.procesandoColaAlojamientos = false;
    },

    async onChangeStageInicio(etapa) {
      const etapaKey = this.getEtapaKey(etapa);
      const proveedorInicio = this.getProveedorAlojamientoInicio(etapa);
      this.limpiarBusquedaStageInicio(etapa);
      this.$set(this.alojamientoInicioSeleccionadoPorEtapa, etapaKey, null);
      const alojamientos = await this.encolarCargaAlojamientos(this.getLocationId(this.stageInicioSeleccionadoPorEtapa[etapaKey]));
      const alojamientoInicio = this.getAlojamientoPreferido(alojamientos, {
        alojamientoIdPivot: etapa?.pivot?.alojamiento_correo_inicio_id,
        proveedor: proveedorInicio,
        nombreAlojamiento: this.getNombreAlojamientoAnterior(etapa),
      });
      this.$set(
        this.alojamientoInicioSeleccionadoPorEtapa,
        etapaKey,
        alojamientoInicio
      );
      await this.persistirAlojamientoCorreoInicioIdEtapa(etapa, this.getAlojamientoId(alojamientoInicio));
    },

    async onChangeStageFin(etapa) {
      const etapaKey = this.getEtapaKey(etapa);
      const proveedorFin = this.getProveedorAlojamientoFin(etapa);
      this.limpiarBusquedaStageFin(etapa);
      this.$set(this.alojamientoFinSeleccionadoPorEtapa, etapaKey, null);
      const alojamientos = await this.encolarCargaAlojamientos(this.getLocationId(this.stageFinSeleccionadoPorEtapa[etapaKey]));
      const alojamientoFin = this.getAlojamientoPreferido(alojamientos, {
        alojamientoIdPivot: etapa?.pivot?.alojamiento_correo_fin_id,
        proveedor: proveedorFin,
        nombreAlojamiento: this.getNombreAlojamiento(etapa),
      });
      this.$set(
        this.alojamientoFinSeleccionadoPorEtapa,
        etapaKey,
        alojamientoFin
      );
      await this.persistirAlojamientoCorreoFinIdEtapa(etapa, this.getAlojamientoId(alojamientoFin));
    },

    nombresAlojReferenciaCoinciden(nombreA, nombreB) {
      const a = this.normalizarTexto(nombreA);
      const b = this.normalizarTexto(nombreB);

      if (!a || !b) {
        return false;
      }

      return a === b || a.includes(b) || b.includes(a);
    },

    async onChangeAlojamientoInicio(etapa, selectedValue = null) {
      const etapaKey = this.getEtapaKey(etapa);
      const proveedorInicio = this.getProveedorAlojamientoInicio(etapa);
      this.limpiarBusquedaAlojamientoInicio(etapa);

      await this.$nextTick();

      const alojamientoSeleccionado = selectedValue || this.alojamientoInicioSeleccionadoPorEtapa[etapaKey];
      await this.persistirAlojamientoCorreoInicioIdEtapa(etapa, this.getAlojamientoId(alojamientoSeleccionado));
      await this.persistirRefAlojamientoCorreoIdProveedor(proveedorInicio, alojamientoSeleccionado);

      if (!alojamientoSeleccionado) {
        return;
      }

      await this.autocompletarMismoAlojamientoEnCards(
        etapa,
        alojamientoSeleccionado,
        this.getNombreAlojamientoAnterior(etapa)
      );
    },

    async onChangeAlojamientoFin(etapa, selectedValue = null) {
      const etapaKey = this.getEtapaKey(etapa);
      const proveedorFin = this.getProveedorAlojamientoFin(etapa);
      this.limpiarBusquedaAlojamientoFin(etapa);

      await this.$nextTick();

      const alojamientoSeleccionado = selectedValue || this.alojamientoFinSeleccionadoPorEtapa[etapaKey];
      await this.persistirAlojamientoCorreoFinIdEtapa(etapa, this.getAlojamientoId(alojamientoSeleccionado));
      await this.persistirRefAlojamientoCorreoIdProveedor(proveedorFin, alojamientoSeleccionado);

      if (!alojamientoSeleccionado) {
        return;
      }

      await this.autocompletarMismoAlojamientoEnCards(
        etapa,
        alojamientoSeleccionado,
        this.getNombreAlojamiento(etapa)
      );
    },

    async autocompletarMismoAlojamientoEnCards(etapaOrigen, alojamientoSeleccionado, nombreAlojOrigen) {
      const nombreAlojReferenciaOrigen = this.normalizarTexto(nombreAlojOrigen);

      if (!nombreAlojReferenciaOrigen || !alojamientoSeleccionado) {
        return;
      }

      const alojamientoSeleccionadoId = this.getAlojamientoId(alojamientoSeleccionado);
      const alojamientoSeleccionadoNombre = this.getAlojamientoLabel(alojamientoSeleccionado);

      for (const etapa of this.etapasIntermedias) {
        const etapaKey = this.getEtapaKey(etapa);

        const referencias = [
          {
            campo: "inicio",
            nombreAloj: this.getNombreAlojamientoAnterior(etapa),
            seleccionado: this.alojamientoInicioSeleccionadoPorEtapa[etapaKey],
            stage: this.stageInicioSeleccionadoPorEtapa[etapaKey],
          },
          {
            campo: "fin",
            nombreAloj: this.getNombreAlojamiento(etapa),
            seleccionado: this.alojamientoFinSeleccionadoPorEtapa[etapaKey],
            stage: this.stageFinSeleccionadoPorEtapa[etapaKey],
          },
        ];

        for (const referencia of referencias) {
          if (!this.nombresAlojReferenciaCoinciden(referencia.nombreAloj, nombreAlojReferenciaOrigen)) {
            continue;
          }

          if (referencia.seleccionado) {
            continue;
          }

          const locationId = this.getLocationId(referencia.stage);
          if (!locationId) {
            continue;
          }

          const alojamientos = await this.encolarCargaAlojamientos(locationId);
          let alojamientoCoincidente = null;

          if (alojamientoSeleccionadoId) {
            alojamientoCoincidente = (alojamientos || []).find(
              (alojamiento) => String(this.getAlojamientoId(alojamiento)) === String(alojamientoSeleccionadoId)
            ) || null;
          }

          if (!alojamientoCoincidente && alojamientoSeleccionadoNombre) {
            alojamientoCoincidente = this.getAlojamientoCoincidente(alojamientos, alojamientoSeleccionadoNombre);
          }

          if (!alojamientoCoincidente) {
            continue;
          }

          if (referencia.campo === "inicio") {
            this.$set(this.alojamientoInicioSeleccionadoPorEtapa, etapaKey, alojamientoCoincidente);
            await this.persistirAlojamientoCorreoInicioIdEtapa(etapa, this.getAlojamientoId(alojamientoCoincidente));
          } else {
            this.$set(this.alojamientoFinSeleccionadoPorEtapa, etapaKey, alojamientoCoincidente);
            await this.persistirAlojamientoCorreoFinIdEtapa(etapa, this.getAlojamientoId(alojamientoCoincidente));
          }
        }
      }
    },

    async cargarAlojamientosPreseleccionados() {
      for (const etapa of this.etapasIntermedias) {
        const etapaKey = this.getEtapaKey(etapa);
        const proveedorInicio = this.getProveedorAlojamientoInicio(etapa);
        const proveedorFin = this.getProveedorAlojamientoFin(etapa);
        const alojamientoInicioIdPivot = etapa?.pivot?.alojamiento_correo_inicio_id;
        const alojamientoFinIdPivot = etapa?.pivot?.alojamiento_correo_fin_id;
        const alojamientosInicio = await this.encolarCargaAlojamientos(this.getLocationId(this.stageInicioSeleccionadoPorEtapa[etapaKey]));
        const alojamientosFin = await this.encolarCargaAlojamientos(this.getLocationId(this.stageFinSeleccionadoPorEtapa[etapaKey]));
        const alojamientoInicio = this.getAlojamientoPreferido(alojamientosInicio, {
          alojamientoIdPivot: alojamientoInicioIdPivot,
          proveedor: proveedorInicio,
          nombreAlojamiento: this.getNombreAlojamientoAnterior(etapa),
        });
        const alojamientoFin = this.getAlojamientoPreferido(alojamientosFin, {
          alojamientoIdPivot: alojamientoFinIdPivot,
          proveedor: proveedorFin,
          nombreAlojamiento: this.getNombreAlojamiento(etapa),
        });
        const alojamientoInicioIdSeleccionado = this.getAlojamientoId(alojamientoInicio);
        const alojamientoFinIdSeleccionado = this.getAlojamientoId(alojamientoFin);

        this.$set(
          this.alojamientoInicioSeleccionadoPorEtapa,
          etapaKey,
          alojamientoInicio
        );
        this.$set(
          this.alojamientoFinSeleccionadoPorEtapa,
          etapaKey,
          alojamientoFin
        );

        await this.persistirAlojamientoCorreoInicioIdEtapa(etapa, alojamientoInicioIdSeleccionado);
        await this.persistirAlojamientoCorreoFinIdEtapa(etapa, alojamientoFinIdSeleccionado);
      }
    },

    async onPrecioYDisponibilidad() {
      if (!this.formularioCompleto || this.loadingPrecioDisponibilidad) {
        return;
      }

      this.loadingPrecioDisponibilidad = true;
      try {
        const response = await this.getPrecioDisponibilidad([
          this.access_token,
          this.correos_access_token,
          this.payloadPrecioDisponibilidad,
        ]);
        this.precioDisponibilidadResponse = response;
        await this.actualizarCosteServicioCorreos(response?.price);
        console.log('Precio y disponibilidad:', response);
      } finally {
        this.loadingPrecioDisponibilidad = false;
      }
    },

    async onCrearReserva() {
      if (!this.formularioCompleto) {
        return;
      }

      console.log("Payload generado para POST /booking:", this.payloadCrearReserva);
      console.log("Payload generado para POST /booking (JSON):", JSON.stringify(this.payloadCrearReserva, null, 2));

      this.loadingCrearReserva = true;
      try {
        const response = await this.createBooking([
          this.access_token,
          this.correos_access_token,
          this.payloadCrearReserva,
        ]);
        console.log("Respuesta POST /booking:", response);
      } catch (error) {
        console.error("Error en POST /booking:", error);
      } finally {
        this.loadingCrearReserva = false;
      }
    },

    async actualizarCosteServicioCorreos(price) {
      const servicioCorreos = this.getServicioCorreos();
      const coste = Number(price);

      if (!servicioCorreos || Number.isNaN(coste)) {
        return;
      }

      const res = await this.updateReservaServicioCoste([
        this.access_token,
        servicioCorreos.reserva_id || this.modelReserva?.id,
        servicioCorreos.servicio_id || servicioCorreos.id,
        coste,
      ]);

      if (res && res.id == this.modelReserva?.id) {
        this.modelReserva.servicios = res.servicios;
      } else {
        servicioCorreos.coste = coste;
      }
    }

  }
};
</script>

<style scoped>
.price-chip-text {
  font-size: 1.15rem;
  font-weight: 700;
}
</style>
